export default "__VITE_ASSET__HntPbut7__"